import "@/App.css";
import "@/styles/accessibility.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppShell from "@/components/AppShell";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Grammar from "@/pages/Grammar";
import History from "@/pages/History";
import Lesson from "@/pages/Lesson";
import LiveClass from "@/pages/LiveClass";
import Login from "@/pages/Login";
import Modules from "@/pages/Modules";
import Profile from "@/pages/Profile";
import Register from "@/pages/Register";
import Review from "@/pages/Review";
import Scenarios from "@/pages/Scenarios";
import TeacherGuide from "@/pages/TeacherGuide";
import UnlockMode from "@/pages/UnlockMode";
import ZeroStart from "@/pages/ZeroStart";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/unlock" element={<UnlockMode />} />
              <Route path="/zero" element={<ZeroStart />} />
              <Route path="/grammar" element={<Grammar />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/live" element={<LiveClass />} />
              <Route path="/review" element={<Review />} />
              <Route path="/scenarios" element={<Scenarios />} />
              <Route path="/lesson/:scenarioId" element={<Lesson />} />
              <Route path="/history" element={<History />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/teacher-guide" element={<TeacherGuide />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
